// Types
type CustomXTickProps = {
	x?: number;
	y?: number;
	payload?: { value: number };
	activeValue: number;
};

const heightAdjustmentFactor = 22;
export default function CustomXTick(props: Readonly<CustomXTickProps>) {
	let { x, y, payload, activeValue } = props;
	x = x ?? 0;
	y = y ?? 0;
	payload = payload ?? { value: 0 };

	const isActive = payload.value === activeValue;

	const width = 23; // adjust the width of the thought cloud
	const height = 18; // adjust the height of the thought cloud
	const pointSize = -6; // adjust the size of the point

	const xOffset = x - width / 2;
	const yOffset = y - height + heightAdjustmentFactor;

	const tailWidth = width / 4; // adjust this to control the width of the tail

	const pathD = `
		M ${xOffset} ${yOffset + height}
		L ${xOffset} ${yOffset + pointSize}
		L ${xOffset + width / 2 - tailWidth / 2} ${yOffset + pointSize}
		L ${xOffset + width / 2} ${yOffset - height / 2}
		L ${xOffset + width / 2 + tailWidth / 2} ${yOffset + pointSize}
		L ${xOffset + width} ${yOffset + pointSize}
		L ${xOffset + width} ${yOffset + height}
		Z
	  `;

	if (isActive) {
		return (
			<g>
				<path d={pathD} fill="white" stroke="#666666" strokeWidth={1.3} fillOpacity={1} strokeOpacity={0.8} />
				<text x={x} y={yOffset + height - 12} textAnchor="middle" dy=".3em" fontFamily="Montserrat" fontSize="12" fill="#666666">
					{payload.value}
				</text>
			</g>
		);
	}

	return (
		<g transform={`translate(${x + 3 + (payload.value >= 10 ? 2 : 0)},${y - 8})`}>
			<text fontSize={10} x={0} y={0} dy={16} fontFamily="Montserrat" textAnchor="end" fill="#666666" fillOpacity={0.9}>
				{payload.value}
			</text>
		</g>
	);
}
